// src/components/BuildingViews/ThievingDummyView.js
import React from 'react';
import styles from './AnvilView.module.css'; // Reuse anvil styles for now

const ThievingDummyView = ({ playerData, onPlayerAction, onGoBack }) => {
  const buildingLevel = playerData.buildings?.thievingDummy?.upgradeLevel || 0;

  return (
    <div className={styles.anvilContainer}>
      {onGoBack && (
        <button 
          className={styles.backButton}
          onClick={onGoBack}
          title="Back to Home"
        >
          ✕
        </button>
      )}
      <div className={styles.anvilHeader}>
        <img src="/img/buildingItems/thievingDummy.png" alt="Thieving Dummy" className={styles.anvilIcon} />
        <div className={styles.anvilInfo}>
          <h2>Thievery Training</h2>
          <p>Level {buildingLevel}</p>
          <p className={styles.description}>
            Practice and improve your stealing skills
          </p>
        </div>
      </div>

      <div className={styles.serviceSection}>
        <h3>🥷 Thievery Training (Coming Soon)</h3>
        <div className={styles.emptyMessage}>
          <p>Train your thievery skills on this practice dummy.</p>
          <p>Features coming soon:</p>
          <ul style={{textAlign: 'left', marginTop: '10px'}}>
            <li>Practice pickpocketing techniques</li>
            <li>Learn lockpicking skills</li>
            <li>Improve stealth and agility</li>
            <li>Unlock advanced thievery abilities</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ThievingDummyView; 